export default "/images/racingstars.svg?acfc80d607f0b68214f4c5f598e0ec85";